var mak = {
    slider: function(){
        $('.slick_slider').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                arrows: false
            });

            $('.aiscr_slider').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                arrows: false
            });
            $('.slider_slick').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                arrows: false
            });
    },
    product_tabs: function(){
        $(document).on("click", ".tab-btn:not(.active)", function(){
            console.log("button clicked!");
            $(".tab-btn,[data-content]").removeClass("active");
            $(this).addClass("active")
            const target = $(this).data("target");
            $("[data-content='"+target+"']").addClass("active");
            $(".content-tab").hide();
            $("[data-content='"+target+"']").show();
        });
    }
}
$(function() {
        mak.slider();
        mak.product_tabs();
});